import { unmountComponentAtNode } from "react-dom";

const MACHINELOGIC_REACT_COMPONENT_ID = "data-machine-logic-react-component-id";

/**
 * This function attaches an method to jquery that lets jquery to be marked with a data attribute that is
 * used to identify machinelogic react components.
 */
export function setupJqueryForMachineLogicReactComponents() {
  $.fn.markAsMachineLogicReactComponent = function(id) {
    this.attr( MACHINELOGIC_REACT_COMPONENT_ID, id );
    return this;
  };
}

/**
 * This function unmounts all react components marked as machinelogic react components.
 *
 * we do this because we need to unmount react nodes before we remove jQuery elements otherwise we
 * get memory leaks and that this cannot be done .on("remove")
 */
export const cleanUpReactElements = () => {
  $(`[${MACHINELOGIC_REACT_COMPONENT_ID}]`).each(function(_, element) {
    unmountComponentAtNode(element);
  });
};

/**
 * This function unmounts all react components marked as machinelogic react components with matching id.
 *
 * we do this because we need to unmount react nodes before we remove jQuery elements otherwise we
 * get memory leaks and that this cannot be done .on("remove")
 * @param {string} id - the id of the react component(s)
 */
export const cleanUpReactElementsByID = (id) => {
  $(`[${MACHINELOGIC_REACT_COMPONENT_ID}=${id}]`).each(function(_, element) {
    unmountComponentAtNode(element);
  });
};